function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.88 25.92L14.4 30.4L28.8 44.8L60.8 12.8L56.32 8.32L28.8 35.84L18.88 25.92ZM57.6 32C57.6 46.08 46.08 57.6 32 57.6C17.92 57.6 6.4 46.08 6.4 32C6.4 17.92 17.92 6.4 32 6.4C34.56 6.4 36.8 6.72 39.04 7.36L44.1601 2.24C40.32 0.96 36.16 0 32 0C14.4 0 0 14.4 0 32C0 49.6 14.4 64 32 64C49.6 64 64 49.6 64 32H57.6Z",
  fill: "#4FBF72"
});

var SvgShape = function SvgShape(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShape, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Shape.6fb5e449.svg";
export { ForwardRef as ReactComponent };